import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import { checkUserAuthorization, loadInitialData } from '../actions/app';


const MainRouter = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authInProgress = useSelector(state => state.app.authInProgress);
  const authComplete = useSelector(state => state.app.authComplete);
  const dataLoaded = useSelector(state => state.app.dataLoaded);

  useEffect(() => {
    const authorize = async () => {
      if (location.pathname === '/login') {
        const searchParams = new URLSearchParams(location.search);
        localStorage.setItem('token', searchParams.get('token'));
      }
      const token = localStorage.getItem('token');

      if (token) {
        await dispatch(checkUserAuthorization(token));
        await dispatch(loadInitialData());
      }
    };
    authorize();
    // Runs once on mount, like the former componentDidMount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const token = localStorage.getItem('token');

  if ((token && !authComplete) || authInProgress) {
    return <div />;
  }

  if (authComplete) {
    return <PrivateRoutes dataLoaded={dataLoaded} />;
  }
  return <PublicRoutes />;
};

export default MainRouter;
